/* eslint-disable no-console */
import { useLayoutEffect, useRef } from "react";

import CallSystemRow from "../../../features/calls/components/CallSystemRow";

import MessageGroup from "./MessageGroup";

const MessageList = ({ messages, currentUserId }) => {
  console.log(messages);
  const listRef = useRef(null);

  useLayoutEffect(() => {
    const list = listRef.current;
    let disposed = false;

    const updateSenderWidth = () => {
      if (disposed) return;
      const names = list.querySelectorAll(".chat-conversation-sender-name");
      let widestName = 0;

      names.forEach((name) => {
        const range = document.createRange();
        range.selectNodeContents(name);
        widestName = Math.max(widestName, range.getBoundingClientRect().width);
      });

      list.style.setProperty("--chat-sender-name-width", `${Math.ceil(widestName)}px`);
    };

    updateSenderWidth();
    const observer = new ResizeObserver(updateSenderWidth);
    observer.observe(list);
    document.fonts?.ready.then(updateSenderWidth);

    return () => {
      disposed = true;
      observer.disconnect();
    };
  }, [messages, currentUserId]);

  const sortedMessages = [...messages].sort(
    (a, b) => new Date(a.created_at) - new Date(b.created_at)
  );

  const groupMessagesByDate = (messages) => {
    return messages.reduce((groups, message) => {
      const date = new Date(message.created_at).toDateString();
      if (!groups[date]) groups[date] = [];
      groups[date].push(message);
      return groups;
    }, {});
  };

  const formatDateSeparator = (dateString) => {
    console.log(dateString);
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) return "Today";
    if (date.toDateString() === yesterday.toDateString()) return "Yesterday";

    return date.toLocaleDateString([], {
      weekday: "long",
      month: "long",
      day: "numeric",
    });
  };

  const groupConsecutiveMessages = (messages) => {
    if (messages.length === 0) return [];

    const grouped = [];
    let currentGroup = [messages[0]];

    for (let i = 1; i < messages.length; i++) {
      const current = messages[i];
      const prev = messages[i - 1];

      const isSameSender = current.sender_id === prev.sender_id;
      console.log(current.created_at + "Z");
      const timeDiff = new Date(current.created_at) - new Date(prev.created_at);
      const isWithin5Minutes = timeDiff < 5 * 60 * 1000;

      if (
        isSameSender &&
        isWithin5Minutes &&
        current.message_type !== "call" &&
        prev.message_type !== "call"
      ) {
        currentGroup.push(current);
      } else {
        grouped.push(currentGroup);
        currentGroup = [current];
      }
    }

    grouped.push(currentGroup);
    return grouped;
  };

  const groupedByDate = groupMessagesByDate(sortedMessages);

  return (
    <div
      ref={listRef}
      className="chat-conversation-messages"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        minHeight: "100%",
      }}
    >
      {Object.entries(groupedByDate).map(([date, dateMessages]) => {
        const consecutiveGroups = groupConsecutiveMessages(dateMessages);

        return (
          <div key={date}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "5px 0",
              }}
            >
              <div
                style={{
                  backgroundColor: "#f1f5f9",
                  color: "#64748b",
                  padding: "6px 16px",
                  borderRadius: "16px",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {formatDateSeparator(date)}
              </div>
            </div>

            {consecutiveGroups.map((group, index) =>
              group[0].message_type === "call" ? (
                <CallSystemRow key={group[0].id || index} message={group[0]} />
              ) : (
                <MessageGroup key={index} group={group} currentUserId={currentUserId} />
              )
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MessageList;
